import { FullProduct } from "ts/api/product";

export const getUniqueProductCategoryIdsBySupplier = (
  products: FullProduct[]
): Record<string, Set<string>> => {
  return products.reduce<Record<string, Set<string>>>((acc, curr) => {
    if (!curr.owner) {
      return acc;
    }
    const currentSupplierCategories = acc[curr.owner.id] ?? new Set();
    for (const cat of curr.categories) {
      currentSupplierCategories.add(cat.mainCategoryId);

      if (cat?.subCategoryId) {
        currentSupplierCategories.add(cat.subCategoryId);
      }
    }

    acc[curr.owner.id] = currentSupplierCategories;
    return acc;
  }, {});
};
